/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type Attestation,
    AttestationFromJSON,
    AttestationToJSON,
} from '../models/Attestation';
import {
    type ChangePasswordRequest,
    ChangePasswordRequestFromJSON,
    ChangePasswordRequestToJSON,
} from '../models/ChangePasswordRequest';
import {
    type GetChallengeChallengeId200Response,
    GetChallengeChallengeId200ResponseFromJSON,
    GetChallengeChallengeId200ResponseToJSON,
} from '../models/GetChallengeChallengeId200Response';
import {
    type GetChallengeChallengeIdV2200Response,
    GetChallengeChallengeIdV2200ResponseFromJSON,
    GetChallengeChallengeIdV2200ResponseToJSON,
} from '../models/GetChallengeChallengeIdV2200Response';
import {
    type GetMe200Response,
    GetMe200ResponseFromJSON,
    GetMe200ResponseToJSON,
} from '../models/GetMe200Response';
import {
    type GetMeOrgs200Response,
    GetMeOrgs200ResponseFromJSON,
    GetMeOrgs200ResponseToJSON,
} from '../models/GetMeOrgs200Response';
import {
    type GetTokenV2200Response,
    GetTokenV2200ResponseFromJSON,
    GetTokenV2200ResponseToJSON,
} from '../models/GetTokenV2200Response';
import {
    type IDRequest,
    IDRequestFromJSON,
    IDRequestToJSON,
} from '../models/IDRequest';
import {
    type IDRequestV2,
    IDRequestV2FromJSON,
    IDRequestV2ToJSON,
} from '../models/IDRequestV2';
import {
    type PostAttestationV3200Response,
    PostAttestationV3200ResponseFromJSON,
    PostAttestationV3200ResponseToJSON,
} from '../models/PostAttestationV3200Response';
import {
    type PostDirectId201Response,
    PostDirectId201ResponseFromJSON,
    PostDirectId201ResponseToJSON,
} from '../models/PostDirectId201Response';
import {
    type PostId200Response,
    PostId200ResponseFromJSON,
    PostId200ResponseToJSON,
} from '../models/PostId200Response';
import {
    type PostPersonsAnonymous201Response,
    PostPersonsAnonymous201ResponseFromJSON,
    PostPersonsAnonymous201ResponseToJSON,
} from '../models/PostPersonsAnonymous201Response';
import {
    type PostSsoResolveRequest,
    PostSsoResolveRequestFromJSON,
    PostSsoResolveRequestToJSON,
} from '../models/PostSsoResolveRequest';
import {
    type PostTokenRequestV2,
    PostTokenRequestV2FromJSON,
    PostTokenRequestV2ToJSON,
} from '../models/PostTokenRequestV2';
import {
    type RecoverRequest,
    RecoverRequestFromJSON,
    RecoverRequestToJSON,
} from '../models/RecoverRequest';

export interface GetChallengeChallengeIdRequest {
    challengeId: string;
    slashIDSdkVersion?: string;
}

export interface GetChallengeChallengeIdV2Request {
    challengeId: string;
    slashIDSdkVersion?: string;
}

export interface GetChallengePackChallengePackIdRequest {
    challengePackId: string;
    slashIDSdkVersion?: string;
}

export interface GetTokenRequest {
    slashIDOrgID: string;
    slashIDSdkVersion?: string;
}

export interface GetTokenV2Request {
    slashIDOrgID: string;
    slashIDSdkVersion?: string;
}

export interface PostAttestationRequest {
    attestation: Attestation;
    slashIDSdkVersion?: string;
}

export interface PostAttestationV2Request {
    attestation: Attestation;
    slashIDSdkVersion?: string;
}

export interface PostAttestationV3Request {
    attestation: Attestation;
    slashIDSdkVersion?: string;
}

export interface PostDirectIdRequest {
    slashIDSdkVersion?: string;
}

export interface PostIdRequest {
    slashIDOrgID: string;
    iDRequest: IDRequest;
    slashIDSdkVersion?: string;
}

export interface PostIdV2Request {
    slashIDOrgID: string;
    iDRequestV2: IDRequestV2;
    slashIDSdkVersion?: string;
}

export interface PostRecoverRequest {
    slashIDOrgID: string;
    recoverRequest: RecoverRequest;
    slashIDSdkVersion?: string;
}

export interface PostSsoResolveOperationRequest {
    slashIDOrgID: string;
    postSsoResolveRequest?: PostSsoResolveRequest;
}

export interface PostTokenV2Request {
    slashIDOrgID: string;
    postTokenRequestV2: PostTokenRequestV2;
    slashIDSdkVersion?: string;
}

export interface PutMeCredentialsPasswordRequest {
    changePasswordRequest: ChangePasswordRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for getChallengeChallengeId without sending the request
     */
    async getChallengeChallengeIdRequestOpts(requestParameters: GetChallengeChallengeIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['challengeId'] == null) {
            throw new runtime.RequiredError(
                'challengeId',
                'Required parameter "challengeId" was null or undefined when calling getChallengeChallengeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenge/{challenge_id}`;
        urlPath = urlPath.replace('{challenge_id}', encodeURIComponent(String(requestParameters['challengeId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getChallengeChallengeIdRaw(requestParameters: GetChallengeChallengeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeId200Response>> {
        const requestOptions = await this.getChallengeChallengeIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getChallengeChallengeId(requestParameters: GetChallengeChallengeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeId200Response | null | undefined > {
        const response = await this.getChallengeChallengeIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 202:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Creates request options for getChallengeChallengeIdV2 without sending the request
     */
    async getChallengeChallengeIdV2RequestOpts(requestParameters: GetChallengeChallengeIdV2Request): Promise<runtime.RequestOpts> {
        if (requestParameters['challengeId'] == null) {
            throw new runtime.RequiredError(
                'challengeId',
                'Required parameter "challengeId" was null or undefined when calling getChallengeChallengeIdV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenge/{challenge_id}/v2`;
        urlPath = urlPath.replace('{challenge_id}', encodeURIComponent(String(requestParameters['challengeId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getChallengeChallengeIdV2Raw(requestParameters: GetChallengeChallengeIdV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeIdV2200Response>> {
        const requestOptions = await this.getChallengeChallengeIdV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeIdV2200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getChallengeChallengeIdV2(requestParameters: GetChallengeChallengeIdV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeIdV2200Response | null | undefined > {
        const response = await this.getChallengeChallengeIdV2Raw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 202:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Creates request options for getChallengePackChallengePackId without sending the request
     */
    async getChallengePackChallengePackIdRequestOpts(requestParameters: GetChallengePackChallengePackIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['challengePackId'] == null) {
            throw new runtime.RequiredError(
                'challengePackId',
                'Required parameter "challengePackId" was null or undefined when calling getChallengePackChallengePackId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenge_pack/{challenge_pack_id}`;
        urlPath = urlPath.replace('{challenge_pack_id}', encodeURIComponent(String(requestParameters['challengePackId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getChallengePackChallengePackIdRaw(requestParameters: GetChallengePackChallengePackIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostId200Response>> {
        const requestOptions = await this.getChallengePackChallengePackIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getChallengePackChallengePackId(requestParameters: GetChallengePackChallengePackIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostId200Response> {
        const response = await this.getChallengePackChallengePackIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMe without sending the request
     */
    async getMeRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/me`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve details of the person and all the organizations they belong to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person details and list of organizations
     */
    async getMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMe200Response>> {
        const requestOptions = await this.getMeRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve details of the person and all the organizations they belong to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person details and list of organizations
     */
    async getMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMe200Response> {
        const response = await this.getMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMeOrgs without sending the request
     */
    async getMeOrgsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/me/orgs`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all the organizations the person belongs to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person list of organizations
     */
    async getMeOrgsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMeOrgs200Response>> {
        const requestOptions = await this.getMeOrgsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMeOrgs200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all the organizations the person belongs to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person list of organizations
     */
    async getMeOrgs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMeOrgs200Response> {
        const response = await this.getMeOrgsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getToken without sending the request
     */
    async getTokenRequestOpts(requestParameters: GetTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling getToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/token`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Given a token for a Person in an Organization, return a new token for the same user in the Organization specified in the SlashID-OrgID request header. For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async getTokenRaw(requestParameters: GetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeIdV2200Response>> {
        const requestOptions = await this.getTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeIdV2200ResponseFromJSON(jsonValue));
    }

    /**
     * Given a token for a Person in an Organization, return a new token for the same user in the Organization specified in the SlashID-OrgID request header. For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async getToken(requestParameters: GetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeIdV2200Response> {
        const response = await this.getTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTokenV2 without sending the request
     */
    async getTokenV2RequestOpts(requestParameters: GetTokenV2Request): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling getTokenV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/token/v2`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async getTokenV2Raw(requestParameters: GetTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTokenV2200Response>> {
        const requestOptions = await this.getTokenV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTokenV2200ResponseFromJSON(jsonValue));
    }

    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async getTokenV2(requestParameters: GetTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTokenV2200Response> {
        const response = await this.getTokenV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postAttestation without sending the request
     */
    async postAttestationRequestOpts(requestParameters: PostAttestationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['attestation'] == null) {
            throw new runtime.RequiredError(
                'attestation',
                'Required parameter "attestation" was null or undefined when calling postAttestation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/attestation`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttestationToJSON(requestParameters['attestation']),
        };
    }

    /**
     */
    async postAttestationRaw(requestParameters: PostAttestationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeId200Response>> {
        const requestOptions = await this.postAttestationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postAttestation(requestParameters: PostAttestationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeId200Response> {
        const response = await this.postAttestationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postAttestationV2 without sending the request
     */
    async postAttestationV2RequestOpts(requestParameters: PostAttestationV2Request): Promise<runtime.RequestOpts> {
        if (requestParameters['attestation'] == null) {
            throw new runtime.RequiredError(
                'attestation',
                'Required parameter "attestation" was null or undefined when calling postAttestationV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/attestation/v2`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttestationToJSON(requestParameters['attestation']),
        };
    }

    /**
     */
    async postAttestationV2Raw(requestParameters: PostAttestationV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeIdV2200Response>> {
        const requestOptions = await this.postAttestationV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeIdV2200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postAttestationV2(requestParameters: PostAttestationV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeIdV2200Response> {
        const response = await this.postAttestationV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postAttestationV3 without sending the request
     */
    async postAttestationV3RequestOpts(requestParameters: PostAttestationV3Request): Promise<runtime.RequestOpts> {
        if (requestParameters['attestation'] == null) {
            throw new runtime.RequiredError(
                'attestation',
                'Required parameter "attestation" was null or undefined when calling postAttestationV3().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/attestation/v3`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttestationToJSON(requestParameters['attestation']),
        };
    }

    /**
     */
    async postAttestationV3Raw(requestParameters: PostAttestationV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostAttestationV3200Response>> {
        const requestOptions = await this.postAttestationV3RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostAttestationV3200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postAttestationV3(requestParameters: PostAttestationV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostAttestationV3200Response> {
        const response = await this.postAttestationV3Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postDirectId without sending the request
     */
    async postDirectIdRequestOpts(requestParameters: PostDirectIdRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/direct-id`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async postDirectIdRaw(requestParameters: PostDirectIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostDirectId201Response>> {
        const requestOptions = await this.postDirectIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostDirectId201ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postDirectId(requestParameters: PostDirectIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostDirectId201Response> {
        const response = await this.postDirectIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postId without sending the request
     */
    async postIdRequestOpts(requestParameters: PostIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling postId().'
            );
        }

        if (requestParameters['iDRequest'] == null) {
            throw new runtime.RequiredError(
                'iDRequest',
                'Required parameter "iDRequest" was null or undefined when calling postId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/id`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDRequestToJSON(requestParameters['iDRequest']),
        };
    }

    /**
     */
    async postIdRaw(requestParameters: PostIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostId200Response>> {
        const requestOptions = await this.postIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postId(requestParameters: PostIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostId200Response> {
        const response = await this.postIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postIdV2 without sending the request
     */
    async postIdV2RequestOpts(requestParameters: PostIdV2Request): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling postIdV2().'
            );
        }

        if (requestParameters['iDRequestV2'] == null) {
            throw new runtime.RequiredError(
                'iDRequestV2',
                'Required parameter "iDRequestV2" was null or undefined when calling postIdV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/id/v2`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDRequestV2ToJSON(requestParameters['iDRequestV2']),
        };
    }

    /**
     */
    async postIdV2Raw(requestParameters: PostIdV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostId200Response>> {
        const requestOptions = await this.postIdV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postIdV2(requestParameters: PostIdV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostId200Response> {
        const response = await this.postIdV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postRecover without sending the request
     */
    async postRecoverRequestOpts(requestParameters: PostRecoverRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling postRecover().'
            );
        }

        if (requestParameters['recoverRequest'] == null) {
            throw new runtime.RequiredError(
                'recoverRequest',
                'Required parameter "recoverRequest" was null or undefined when calling postRecover().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/recover`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecoverRequestToJSON(requestParameters['recoverRequest']),
        };
    }

    /**
     */
    async postRecoverRaw(requestParameters: PostRecoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostId200Response>> {
        const requestOptions = await this.postRecoverRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postRecover(requestParameters: PostRecoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostId200Response> {
        const response = await this.postRecoverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postSsoResolve without sending the request
     */
    async postSsoResolveRequestOpts(requestParameters: PostSsoResolveOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling postSsoResolve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sso/resolve`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostSsoResolveRequestToJSON(requestParameters['postSsoResolveRequest']),
        };
    }

    /**
     * Resolve endpoint for SSO flows using PKCE.
     * SSO resolve challenge endpoint
     */
    async postSsoResolveRaw(requestParameters: PostSsoResolveOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postSsoResolveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resolve endpoint for SSO flows using PKCE.
     * SSO resolve challenge endpoint
     */
    async postSsoResolve(requestParameters: PostSsoResolveOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postSsoResolveRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for postTokenV2 without sending the request
     */
    async postTokenV2RequestOpts(requestParameters: PostTokenV2Request): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling postTokenV2().'
            );
        }

        if (requestParameters['postTokenRequestV2'] == null) {
            throw new runtime.RequiredError(
                'postTokenRequestV2',
                'Required parameter "postTokenRequestV2" was null or undefined when calling postTokenV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/token/v2`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostTokenRequestV2ToJSON(requestParameters['postTokenRequestV2']),
        };
    }

    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async postTokenV2Raw(requestParameters: PostTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTokenV2200Response>> {
        const requestOptions = await this.postTokenV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTokenV2200ResponseFromJSON(jsonValue));
    }

    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async postTokenV2(requestParameters: PostTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTokenV2200Response> {
        const response = await this.postTokenV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for putMeCredentialsPassword without sending the request
     */
    async putMeCredentialsPasswordRequestOpts(requestParameters: PutMeCredentialsPasswordRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['changePasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'changePasswordRequest',
                'Required parameter "changePasswordRequest" was null or undefined when calling putMeCredentialsPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/me/credentials/password`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordRequestToJSON(requestParameters['changePasswordRequest']),
        };
    }

    /**
     * Creates or overwrites the password credential linked to the person identified by the token. This credential will then be available for use in future authentication challenges. 
     * Create or overwrite a password credential for the person identified by the token.
     */
    async putMeCredentialsPasswordRaw(requestParameters: PutMeCredentialsPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostPersonsAnonymous201Response>> {
        const requestOptions = await this.putMeCredentialsPasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPersonsAnonymous201ResponseFromJSON(jsonValue));
    }

    /**
     * Creates or overwrites the password credential linked to the person identified by the token. This credential will then be available for use in future authentication challenges. 
     * Create or overwrite a password credential for the person identified by the token.
     */
    async putMeCredentialsPassword(requestParameters: PutMeCredentialsPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostPersonsAnonymous201Response> {
        const response = await this.putMeCredentialsPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
